var map = {
	"./af.json": 8514,
	"./am.json": 51627,
	"./ar.json": 42478,
	"./az.json": 66054,
	"./be.json": 7768,
	"./bg.json": 75818,
	"./bn.json": 70205,
	"./br.json": 75313,
	"./bs.json": 25526,
	"./ca.json": 34029,
	"./cs.json": 50467,
	"./cy.json": 23669,
	"./da.json": 31370,
	"./de.json": 12870,
	"./dv.json": 95767,
	"./el.json": 40716,
	"./en.json": 91038,
	"./es.json": 88789,
	"./et.json": 6964,
	"./eu.json": 84999,
	"./fa.json": 4144,
	"./fi.json": 80872,
	"./fr.json": 84477,
	"./ga.json": 34537,
	"./gl.json": 73898,
	"./ha.json": 97974,
	"./he.json": 51994,
	"./hi.json": 31070,
	"./hr.json": 10311,
	"./hu.json": 48266,
	"./hy.json": 48942,
	"./id.json": 17048,
	"./is.json": 70193,
	"./it.json": 46536,
	"./ja.json": 44668,
	"./ka.json": 27445,
	"./kk.json": 54243,
	"./km.json": 74441,
	"./ko.json": 88975,
	"./ku.json": 13425,
	"./ky.json": 37805,
	"./lt.json": 25305,
	"./lv.json": 64575,
	"./mk.json": 96709,
	"./ml.json": 88100,
	"./mn.json": 26806,
	"./mr.json": 68658,
	"./ms.json": 52637,
	"./mt.json": 48732,
	"./nb.json": 60021,
	"./nl.json": 98255,
	"./nn.json": 70729,
	"./no.json": 84366,
	"./pl.json": 2565,
	"./ps.json": 17116,
	"./pt.json": 70653,
	"./ro.json": 71906,
	"./ru.json": 7512,
	"./sd.json": 42382,
	"./sk.json": 38395,
	"./sl.json": 39782,
	"./so.json": 61223,
	"./sq.json": 34797,
	"./sr.json": 93680,
	"./sv.json": 16940,
	"./sw.json": 54079,
	"./ta.json": 22682,
	"./tg.json": 12292,
	"./th.json": 35885,
	"./tr.json": 96955,
	"./tt.json": 91841,
	"./ug.json": 96289,
	"./uk.json": 56413,
	"./ur.json": 10778,
	"./uz.json": 37570,
	"./vi.json": 56440,
	"./zh.json": 65463
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21495;